import { render, staticRenderFns } from "./scanner.vue?vue&type=template&id=491c28d9&scoped=true&"
import script from "./scanner.vue?vue&type=script&lang=js&"
export * from "./scanner.vue?vue&type=script&lang=js&"
import style0 from "./scanner.vue?vue&type=style&index=0&id=491c28d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491c28d9",
  null
  
)

export default component.exports